export default "__VITE_ASSET__Bt$8XeUC__"